import { $ } from '@/libs/jquery/index'
import 'tinymce/jquery.tinymce'
import tinymce from 'tinymce/tinymce'

import { getDefaultCssPackPath } from '@/libs/tinymce/utils'

import { articleSettings as article } from '@/libs/tinymce/presets/article'
import { bgContentSettings as bgcontent } from '@/libs/tinymce/presets/bank_guarantee_content'
import { bgSliderSettings as bgslider} from '@/libs/tinymce/presets/bank_guarantee_slider'
import { defaultSettings } from '@/libs/tinymce/presets/default'
import { emptySettings as empty } from '@/libs/tinymce/presets/empty'
import { knowledgeSettings as knowledge } from '@/libs/tinymce/presets/knowledges'
import { platformSettings as platform } from '@/libs/tinymce/presets/platform'
import { postSettings as post } from '@/libs/tinymce/presets/post'
import { questionsSettings as question } from '@/libs/tinymce/presets/question'

import 'tinymce/themes/silver/index'

import 'tinymce/plugins/code'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/table'
import 'tinymce/plugins/wordcount'

// Селектор по которому будет идти замена
export const selector: string = 'textarea.tinymce:not(.disabled)'

const presets = {
  article,
  bgcontent,
  bgslider,
  default: defaultSettings,
  empty,
  knowledge,
  platform,
  post,
  question,
}

// Прицепить редактор к элементу
export const attachTinyMCEToTextarea = (element: HTMLElement) => {
  // Аназилируем `data-tinymce-preset` что бы понять какой редактор нужно создать
  // Варианты:
  //  - нет аттрибута (редактор по умочанию)
  //  - empty (с минимальным функционалом)
  const settings = (element.dataset && element.dataset.tinymcePreset)
    ? presets[element.dataset.tinymcePreset]
    : presets.default

  $(element).tinymce({
    content_css: getDefaultCssPackPath(),
    language: 'ru',
    ...settings,
    skin_url: '/packs/skins/ui/oxide/',
  })

  tinymce.i18n.add('ru', {
    'Current window': '\u0422\u0435\u043a\u0443\u0449\u0435\u0435 \u043e\u043a\u043d\u043e',
    'Open link in...': '\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u0441\u0441\u044b\u043b\u043a\u0443 \u0432...',
  })
}

export const deAttachTinyMCEToTextarea = (element: string) => {
  tinymce.remove(element)
}

// Прицепить редакторы ко всем заматченным элементам
export const TinyMceInit = () => {
  tinymce.init({
    ...defaultSettings,
    selector,
    setup: (editor) => {
      editor.on('change', () => editor.save())
    },
  })
}

export const tinyMceSave = () => {
  tinymce.triggerSave()
}
